import { render } from "./haman.vue?vue&type=template&id=0b2592f1"
import script from "./haman.vue?vue&type=script&lang=js"
export * from "./haman.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__